import { AxiosResponse } from 'axios';
import { emitError } from './errorEmitter';

export const errorHandler = (error: AxiosResponse) => {
    const { status } = error;

    let message: string;
    let title: string;
    switch (status) {
        case 400:
            title = 'BAD_REQUEST_TITLE';
            message = 'BAD_REQUEST_DESCRIPTION';
            break;
        case 401:
            title = 'SESSION_EXPIRED_TITILE';
            message = 'SESSION_EXPIRED_DESCRIPTION';
            break;
        case 403:
            title = 'INSUFFICIENT_PRIVILEGES_TITLE';
            message = 'INSUFFICIENT_PRIVILEGES_DESCRIPTION';
            break;
        case 404:
            title = 'NOT_FOUND_TITLE';
            message = 'NOT_FOUND_DESCRIPTION';
            break;
        case 429:
            title = 'TOO_MANY_REQUESTS_TITLE';
            message = 'TOO_MANY_REQUESTS_DESCRIPTION';
            break;
        default:
            title = 'UNEXPECTED_ERROR_TITLE';
            message = 'UNEXPECTED_ERROR_DESCRIPTION';
    }

    // Show error message to user
    emitError(title, message, status.toString());

    // Reject the promise
    return Promise.reject(error);
};
